import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { StockService } from './stock.service';
import { HttpClientModule } from '@angular/common/http';
import { CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA } from '@angular/core';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';


import { AppComponent } from './app.component';
import {CustomMaterialModule} from './custom-material/custom-material.module';
import {NgbModule} from '@ng-bootstrap/ng-bootstrap';


@NgModule({
  declarations: [
    AppComponent
  ],
  imports: [
    BrowserModule, HttpClientModule, NgbModule.forRoot(), BrowserAnimationsModule, CustomMaterialModule
  ],
  providers: [StockService],
  bootstrap: [AppComponent],
  schemas:[CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA]
})
export class AppModule { }



// WEBPACK FOOTER //
// ./src/app/app.module.ts